<template>
  <div class="home_partner">
    <div class="gsjj">
      <p class="p1">合作伙伴</p>
      <div class="fg"></div>
    </div>
    <div class="box">
      <img src="../../assets/images/partner/partnerList.png" alt="">
      <!-- <el-row style="width: 100%">
        <el-col :span="8" v-for="(item, index) in list" :key="index" style="text-align: center;">
          <div class="item" >
            <img :style="{ width: item.width, height: item.height }" :src="item.imgUrl" alt="" />
          </div>
        </el-col>
      </el-row> -->
    </div>
    <!-- <div class="init">
      <div class="title">/ 合作伙伴 /</div>
      <div class="cont">
        <div v-for="(item, index) in partnerList" :key="index" class="item">
          <a class="img" :href="item.href" target="_blank">
            <img :src="baseConfig.baseUrl+item.imageUrl" alt="" />
          </a>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import { getBannerList } from "@/apis/banner";

export default {
  components: {},
  data() {
    return {
      partnerList: [],
      list: [
        {
          imgUrl: require("@/assets/images/partner/image1.png"),
          width: "520px",
          height: "58px",
        },
        {
          imgUrl: require("@/assets/images/partner/image2.png"),
          width: "334px",
          height: "114.5px",
        },
        {
          imgUrl: require("@/assets/images/partner/image3.png"),
          width: "334px",
          height: "58px",
        },
        {
          imgUrl: require("@/assets/images/partner/image4.png"),
          width: "334px",
          height: "95.96px",
        },
        {
          imgUrl: require("@/assets/images/partner/image5.png"),
          width: "334px",
          height: "44.53px",
        },
        {
          imgUrl: require("@/assets/images/partner/image6.png"),
          width: "334px",
          height: "116.69px",
        },
        {
          imgUrl: require("@/assets/images/partner/image7.png"),
          width: "435px",
          height: "57px",
        },
        {
          imgUrl: require("@/assets/images/partner/image8.png"),
          width: "245.93px",
          height: "79.36px",
        },
        {
          imgUrl: require("@/assets/images/partner/image9.png"),
          width: "334px",
          height: "83.98pxpx",
        },
        {
          imgUrl: require("@/assets/images/partner/image10.png"),
          width: "334px",
          height: "97.42px",
        },
        {
          imgUrl: require("@/assets/images/partner/image11.png"),
          width: "334px",
          height: "65.57px",
        },
        {
          imgUrl: require("@/assets/images/partner/image12.png"),
          width: "334px",
          height: "94.46px",
        },
        {
          imgUrl: require("@/assets/images/partner/image13.png"),
          width: "334px",
          height: "67.2px",
        },
        {
          imgUrl: require("@/assets/images/partner/image14.png"),
          width: "308px",
          height: "97.32px",
        },
        {
          imgUrl: require("@/assets/images/partner/image15.png"),
          width: "334px",
          height: "47.51px",
        },
      ],
    };
  },
  created() {
    var me = this;
    me.loadBannerList(
      {
        position: "合作伙伴",
        status: "0",
        pageSize: 10,
        pageNum: 1,
      },
      function () {}
    );
  },
  methods: {
    loadBannerList(params, onInit) {
      let me = this;
      getBannerList(params).then((rst) => {
        me.partnerList = rst.rows;
        onInit && onInit();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home_partner {
  width: 100%;
  // height: 825px;
  background-color: #fafafa;
  background-image: url(../../assets/images/partner/partner.png);
  background-size: cover; /* 将背景图片拉伸或缩放以铺满容器 */
  /* background-color: #19f900; */
  /* border: 1px dashed #000; */
}

.gsjj {
  width: 208px;
  height: 99px;
  /* background-color: #073875; */
  margin: 0 auto;
  padding-top: 53px;
  /* margin-bottom: 5px; */
  margin-bottom: 80px;
  /* margin-top: 100px; */
}
.fg {
  width: 165px;
  height: 5px;
  background: #0a41ff;
  border-radius: 0px 0px 0px 0px;
  margin: 47px 21px 0px 22px;
}
.p1 {
  width: 208px;
  height: 52px;
  font-size: 52px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  line-height: 93px;
  /* // -webkit-background-clip: text; */
  /* // -webkit-text-fill-color: transparent; */
}
.box {
  width: 1600px;
  // background-image: url(../../assets/images/partner/partnerList.png);
  // height: 600px;
  margin: 0 auto;
  height: 600px;
  // .item {
  //   margin-bottom: 40px;
  //   height: 120px;
  //   line-height: 120px;
  //   width: auto;
  // }
  img{
    width: 100%;
    height: 100%;
  }
}
.box > ul {
  width: 1605px;
  height: 555px;
  display: flex;
  flex-wrap: wrap;
  /* background-color: #b91414; */
  margin-top: 50px;
  margin: 0 auto;
}
.box > ul > li {
  margin-top: 20px;
  width: 535px;
  height: 165px;
  /* background-color: pink; */
}
.init {
  width: 80%;
  margin: 0 auto;
  max-width: 1196px;
}

.title {
  color: #073875;
  line-height: 0.48rem;
  font-size: 0.48rem;
  text-align: center;
}

.cont {
  width: 100%;
  margin: 0.4rem 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.item {
  width: 20%;
  text-align: center;
  display: flex;
  justify-content: center;
}

.img {
  width: 90%;
  margin: 0.1rem;
  line-height: 0.8rem;
  font-size: 0rem;
  background-color: #fafafa;
}

.img:hover,
.img:active {
  background-color: #f3f3f3;
  box-shadow: 3px 3px 6px -4px rgb(0 0 0 / 15%);
}

.img img {
  width: 80%;
}

</style>